var render = function render(){var _vm=this,_c=_vm._self._c;return _c('registrationHS',{on:{"success":_vm.emitDecks}})
}
var staticRenderFns = []

export { render, staticRenderFns }